import { render } from "./tryBottomBar.vue?vue&type=template&id=035b31bd"
import script from "./tryBottomBar.vue?vue&type=script&lang=js"
export * from "./tryBottomBar.vue?vue&type=script&lang=js"

import "./tryBottomBar.vue?vue&type=style&index=0&id=035b31bd&lang=css"
script.render = render

export default script